import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  const closeMenu = () => setIsMenuOpen(false);

  const navLinkClass = (path) =>
    `block px-4 py-4 text-base font-medium border-b border-gray-700 ${
      isActive(path)
        ? 'bg-brand-coral text-white'
        : 'text-white hover:bg-brand-gray-dark'
    }`;

  return (
    <>
      <nav className="bg-brand-black shadow-sm print:hidden">
        <div className="px-4">
          <div className="flex justify-between items-center h-14">
            {/* Logo - image only on mobile, with text on desktop */}
            <Link to="/" className="flex items-center">
              <img src="/logoswyft.jpg" alt="Swyft" className="h-8 w-auto" />
              <span className="ml-2 text-lg font-bold text-white hidden lg:inline">Swyft Restoration</span>
            </Link>

            {/* Desktop Navigation - ONLY shows on lg (1024px) and up */}
            <div className="hidden lg:flex items-center space-x-2">
              <Link to="/" className={`px-3 py-2 rounded-md text-sm font-medium ${isActive('/') ? 'bg-brand-coral text-white' : 'text-gray-300 hover:text-white'}`}>
                Dashboard
              </Link>
              <Link to="/schedule" className={`px-3 py-2 rounded-md text-sm font-medium ${isActive('/schedule') ? 'bg-brand-coral text-white' : 'text-gray-300 hover:text-white'}`}>
                Schedule
              </Link>
              <Link to="/properties" className={`px-3 py-2 rounded-md text-sm font-medium ${isActive('/properties') ? 'bg-brand-coral text-white' : 'text-gray-300 hover:text-white'}`}>
                Properties
              </Link>
              <Link to="/jobs/new" className={`px-3 py-2 rounded-md text-sm font-medium ${isActive('/jobs/new') ? 'bg-brand-coral text-white' : 'text-gray-300 hover:text-white'}`}>
                Add Job
              </Link>
              <Link to="/activity" className={`p-2 rounded-md ${isActive('/activity') ? 'bg-brand-coral text-white' : 'text-gray-300 hover:text-white'}`} title="Activity">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </Link>
              <Link to="/account" className={`p-2 rounded-md ${isActive('/account') ? 'bg-brand-coral text-white' : 'text-gray-300 hover:text-white'}`} title="Account">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </Link>
              <button onClick={handleLogout} className="px-3 py-2 text-sm font-medium text-gray-300 hover:text-white rounded-md">
                Logout
              </button>
            </div>

            {/* Mobile Hamburger Button - ONLY shows below lg */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 rounded-md text-gray-300 hover:text-white"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Sidebar Overlay */}
      {isMenuOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50"
            onClick={closeMenu}
          />

          {/* Sidebar */}
          <div className="fixed top-0 right-0 h-full w-64 bg-brand-black shadow-xl">
            {/* Close button */}
            <div className="flex justify-end p-4">
              <button
                onClick={closeMenu}
                className="p-2 text-gray-300 hover:text-white"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Menu Items */}
            <div className="flex flex-col">
              <Link to="/" onClick={closeMenu} className={navLinkClass('/')}>
                Dashboard
              </Link>
              <Link to="/schedule" onClick={closeMenu} className={navLinkClass('/schedule')}>
                Schedule
              </Link>
              <Link to="/properties" onClick={closeMenu} className={navLinkClass('/properties')}>
                Properties
              </Link>
              <Link to="/jobs/new" onClick={closeMenu} className={navLinkClass('/jobs/new')}>
                Add Job
              </Link>
              <Link to="/activity" onClick={closeMenu} className={navLinkClass('/activity')}>
                Activity Log
              </Link>
              <Link to="/account" onClick={closeMenu} className={navLinkClass('/account')}>
                Account Settings
              </Link>
              <button
                onClick={() => { closeMenu(); handleLogout(); }}
                className="block w-full text-left px-4 py-4 text-base font-medium text-white hover:bg-brand-gray-dark border-b border-gray-700"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;
